import { Campaign } from '../../types';

export const getFormInitialValues = (campaign?: Campaign) => {
  if (!campaign) {
    return;
  }

  const fields = campaign.formFields.fields.map((field) => {
    if (typeof field === 'object' && 'defaultValue' in field) {
      if (typeof field.defaultValue === 'string') {
        return field.defaultValue.trim();
      }

      return field.defaultValue;
    }

    return '';
  });

  return { fields };
};
